import { SectionStyle } from '@/types/site.interface'

export const sectionStyleMap: { [key in SectionStyle]: string } = {
  default: 'bg-section-default',
  highlight: 'bg-section-higlight',
}
